import { History, Shield } from "lucide-react";

export const BidHistory = ({ bids }) => (
  <div className="glass-card p-6">
    <h3 className="text-lg text-[#EDEDED] mb-4 flex items-center gap-2">
      <History className="w-5 h-5 text-[#D4AF37]" /> Bid History
    </h3>

    {bids.length === 0 ? (
      <p className="text-[#71717A] text-sm text-center py-4">No bids yet. Be the first!</p>
    ) : (
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {bids.map((bid, idx) => (
          <div
            key={bid.bid_id}
            className={`flex items-center justify-between p-2 rounded ${
              idx === 0 ? "bg-[#D4AF37]/10" : "bg-[#18181B]"
            }`}
          >
            <div className="flex items-center gap-2">
              {idx === 0 && <Shield className="w-4 h-4 text-[#D4AF37]" />}
              <span className="text-sm text-[#A1A1AA]">{bid.bidder_display}</span>
            </div>
            <div className="text-right">
              <p className={`font-medium ${idx === 0 ? "text-[#D4AF37]" : "text-[#EDEDED]"}`}>
                ${bid.amount.toLocaleString()}
              </p>
              <p className="text-xs text-[#52525B]">
                {new Date(bid.created_at).toLocaleTimeString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
